var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { maryOf } from "./MaryProvider";
/**
 *
 */
export var MaryActionPrefix = "Mary/";
/**
 *
 */
export var MaryActionTypeKeys;
(function (MaryActionTypeKeys) {
    MaryActionTypeKeys["MARY_INIT"] = "MARY/INIT";
    MaryActionTypeKeys["MARY_UPDATE"] = "MARY/UPDATE";
    MaryActionTypeKeys["MARY_UNLINK"] = "MARY/UNLINK";
    MaryActionTypeKeys["MARY_FLEX_SET_FOCUS"] = "MARY/FLEX_SET_FOCUS";
    MaryActionTypeKeys["MARY_MODAL_SET_ACTIVE"] = "MARY/MODAL_SET_ACTIVE";
    MaryActionTypeKeys["MARY_MODAL_DISABLE_ACTIVE"] = "MARY/MODAL_DISABLE_ACTIVE";
})(MaryActionTypeKeys || (MaryActionTypeKeys = {}));
/**
 *
 */
export var maryInit = function (props) { return (__assign({ type: MaryActionTypeKeys.MARY_INIT }, props)); };
/**
 *
 * @param props
 */
export var maryUpdate = function (props) { return (__assign({ type: MaryActionTypeKeys.MARY_UPDATE }, props)); };
/**
 *
 */
export var maryUnlink = function () { return ({
    type: MaryActionTypeKeys.MARY_UNLINK,
}); };
/**
 *
 * @param to
 */
export var flexSetFocus = function (to) { return (function (_dispatch, getState) {
    maryOf(getState()).prop("flex").prop("setFocus")(to);
}); };
/**
 *
 * @param to
 */
export var modalShow = function (id, me) { return (function (_dispatch, getState) {
    maryOf(getState()).prop("modal").prop("showModal")(id, me);
}); };
/**
 *
 */
export var modalClose = function (id) { return (function (_dispatch, getState) {
    maryOf(getState()).prop("modal").prop("closeModal")(id);
}); };
